/* eslint-disable react/no-array-index-key */
import { Tabs } from '@coop/components';
import React from 'react';

import type { ApiRecipe, ApiRecipePart } from '../../../../../models/recipe/recipeModel';
import { mapToIngredientProps, mapToRecipeCookingInstructions } from '../../../utils/recipeUtils';
import styles from './BuyableRecipeDetails.module.scss';

const Ingredients = (props: { recipeParts: ApiRecipePart[]; defaultPortions: number }) => {
    const recipeParts = props.recipeParts.map((part) => ({
        part: part.name,
        ingredients: mapToIngredientProps(part.ingredients),
    }));

    const ingredientLine = (formattedQuantity: string, unit: string, friendlyText: string) => {
        if (formattedQuantity) {
            return `${formattedQuantity} ${unit} ${friendlyText}`;
        }

        return friendlyText;
    };

    return recipeParts.map(({ part, ingredients }, i) => {
        const uniqueKey = `${part}_${i}`;

        return (
            <div key={uniqueKey}>
                <h3 className={styles.IngredientsListHeader} id={uniqueKey}>
                    {part ||
                        `Ingredienser${props.defaultPortions > 0 && ` (för ${props.defaultPortions} portioner)`}`}
                </h3>
                <ul className={styles.IngredientsList} aria-labelledby={uniqueKey}>
                    {ingredients.map(({ formattedQuantity, unit, friendlyText }, index) => (
                        <li key={`${index}_${friendlyText}`}>
                            {ingredientLine(formattedQuantity, unit, friendlyText)}
                        </li>
                    ))}
                </ul>
            </div>
        );
    });
};

const BuyableRecipeDetailsMaybeTabs = (props: { recipe: ApiRecipe }) => {
    const { recipe } = props;

    const cookingInstructions = recipe
        ? mapToRecipeCookingInstructions(recipe.cookingInstructions)
        : [];

    if (recipe.isFoodBox) {
        return <Ingredients recipeParts={recipe.recipePart} defaultPortions={recipe.yieldValue} />;
    }

    return (
        <Tabs.Root>
            <Tabs.List>
                <Tabs.Tab id="ingredients">Ingredienser</Tabs.Tab>
                <Tabs.Tab id="cookingInstructions">Gör så här</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel id="ingredients" className={styles.TabPanel}>
                <Ingredients recipeParts={recipe.recipePart} defaultPortions={recipe.yieldValue} />
            </Tabs.Panel>
            <Tabs.Panel id="cookingInstructions" className={styles.TabPanel}>
                <div className={styles.CookingInstructions}>
                    {cookingInstructions.map(({ title, instructions }, i) => (
                        <React.Fragment key={i}>
                            {title && <h3 className="u-textWeightBold">{title}</h3>}
                            {!!instructions?.length && (
                                <ul>
                                    {instructions.map((el, e) => (
                                        <li key={e}>{el}</li>
                                    ))}
                                </ul>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </Tabs.Panel>
        </Tabs.Root>
    );
};

export default BuyableRecipeDetailsMaybeTabs;
